angular.module('ngIntlTelInput', []);


// WEBPACK FOOTER //
// ./public/javascript/lib/ngTelInput/ng-intl-tel-input.module.js